<pbc-filter-preset
  [filter]="tage.preset$ | async"
  [filters]="tage.presets$ | async"
  [name]="tage.search$ | async"
  (select)="tage.setFilter($event)"
  (save)="tage.writeFilter($event)"
  (delete)="tage.deleteFilter($event)"
></pbc-filter-preset>
